import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const inspectionConfig = {
  /* ------------------------------- GET ---------------------------------- */

  getAllInspections: {
    key: "getAllInspections",
    url: "/api/v1/inspections",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getRoomInventoryForInspection: {
    key: "getRoomInventoryForInspection",
    url: (data) => `/api/v1/inspections/rooms/${data.roomId}/inventory`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  getCheckoutInspectionStatuses: {
    key: "getCheckoutInspectionStatuses",
    url: "/api/v1/inspections/checkout-statuses",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getStaffInspections: {
    key: "getStaffInspections",
    url: "/api/v1/inspections/staff/me",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getInspectionStaffForProperty: {
    key: "getInspectionStaffForProperty",
    url: "/api/v1/inspections/staff",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getInspectionById: {
    key: "getInspectionById",
    url: (data) => `/api/v1/inspections/${data.inspectionId || data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  createInspection: {
    key: "createInspection",
    url: "/api/v1/inspections",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllInspections"],
      onSuccessMessage: "Inspection created successfully",
      onErrorMessage: "Failed to create inspection",
    },
  },

  startInspection: {
    key: "startInspection",
    url: (data) =>
      `/api/v1/inspections/${data.inspectionId || data.id}/start`,
    method: "POST",
    options: {
      retry: 0,
      invalidateKeys: ["getAllInspections", "getStaffInspections"],
      onSuccessMessage: "Inspection started successfully",
      onErrorMessage: "Failed to start inspection",
    },
  },

  createCheckoutInspection: {
    key: "createCheckoutInspection",
    url: "/api/v1/inspections/checkout",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllInspections"],
      onSuccessMessage: "Checkout inspection created successfully",
      onErrorMessage: "Failed to create checkout inspection",
    },
  },

  createFolioItemForInspection: {
    key: "createFolioItemForInspection",
    url: (data) =>
      `/api/v1/inspections/${data.inspectionId || data.id}/folio-items`,
    method: "POST",
    options: {
      retry: 0,
      invalidateKeys: ["getAllInspections"],
      onSuccessMessage: "Inspection charges posted to folio",
      onErrorMessage: "Failed to post inspection charges",
    },
  },

  completeInspection: {
    key: "completeInspection",
    url: (data) =>
      `/api/v1/inspections/${data.inspectionId || data.id}/complete`,
    method: "POST",
    options: {
      retry: 0,
      invalidateKeys: [
        "getAllInspections",
        "getCheckoutInspectionStatuses",
        "getStaffInspections",
      ],
      onSuccessMessage: "Inspection completed successfully",
      onErrorMessage: "Failed to complete inspection",
    },
  },

  refill: {
    key: "refill",
    url: (data) =>
      `/api/v1/inspections/${data.inspectionId || data.id}/refill`,
    method: "POST",
    options: {
      retry: 0,
      invalidateKeys: ["getAllInspections", "getStaffInspections"],
      onSuccessMessage: "Room inventory refilled to PAR levels",
      onErrorMessage: "Failed to refill room inventory",
    },
  },

  assignInspection: {
    key: "assignInspection",
    url: (data) =>
      `/api/v1/inspections/${data.inspectionId || data.id}/assign`,
    method: "POST",
    options: {
      retry: 0,
      invalidateKeys: ["getAllInspections", "getStaffInspections"],
      onSuccessMessage: "Inspection assigned successfully",
      onErrorMessage: "Failed to assign inspection",
    },
  },
};
